import style from "./index.module.css";

const SidebarBox = ({
  children,
  classes,
}: {
  children: any;
  classes?: string;
}) => {
  return (
    <div className={`${style.box}${classes ? ` ${classes}` : ""}`}>
      {children}
    </div>
  );
};

export default SidebarBox;
